@if(estateProperties()?.length > 0) {
<div class="key-info">
    <div class="left-column">
        @for (properties of estateProperties(); track $index) { @if (properties?.position === "left") {
        <div class="key-value">
            @if (properties?.heading) {
            <div>{{ properties?.heading }}</div>
            <div>{{ properties.value }} {{ properties.notation }}</div>
            }
        </div>
        } }
    </div>
    <div class="right-column">
        @for (properties of estateProperties(); track $index) { @if (properties?.position === "right") {
        <div class="key-value">
            @if (properties?.heading) {
            <div>{{ properties?.heading }}</div>
            <div>{{ properties.value }} {{ properties.notation }}</div>
            }
        </div>
        } }
    </div>
</div>
}
